// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1-IR1","title":"Header_title__1CtVF","left":"Header_left__2IWhW","clinicName":"Header_clinicName__OtDhz"};